<template>
  <div class="container series-container">
    <h1>{{ heading }}</h1>
    <div v-html="$store.state.initialData.collectionsContent" class="txt"></div>
    <collection-list :items="seriesList"></collection-list>
  </div>
</template>

<script>
import CollectionList from "@/components/series/CollectionList.vue";

export default {
  name: `videoCollection`,

  components: {
    CollectionList
  },

  computed: {
    heading() {
      return `סדרות`;
    },

    seriesList() {
      // eslint-disable-next-line
      return this.$store.state.series.filter(item => item.parent !== `10`);
    },

    isLoggedIn() {
      return this.$store.state.user.isLoggedIn;
    }
  }
};
</script>

<style lang="scss">
.series-container {
  .txt {
    margin-bottom: 2em;
  }
}
</style>
